import { Loadable } from '..';

export interface MvnoBundle {
  Id: number;
  Msisdn: string;
  CreatedOnUtc: Date;
  StartDateUtc: Date;
  RenewalDateUtc: Date;
  ExpirationDateUtc: Date | null;
  Period: any;
  AllowanceMB: number;
  Status: string;
  Topups: Array<MvnoBundleTopUp> | null;
}

export interface MvnoBundleTopUp {
  amountMB: number;
  createdOnUtc: Date;
}

export type MvnoBundleState = Loadable<MvnoBundle>;

export const getDefaultMvnoBundleState = (): MvnoBundleState => {
  return {
    Id: 0,
    Msisdn: '',
    CreatedOnUtc: new Date(),
    StartDateUtc: new Date(),
    RenewalDateUtc: new Date(),
    ExpirationDateUtc: null,
    Period: 'unknown',
    AllowanceMB: 0,
    isLoading: false,
    Status: '',
    Topups: null
  };
};
